import {useWeaveflowRouteContext} from '../context';
import {useWeaveInWorkspace} from '../context/WeaveInWorkspaceContext';

export function useSmallRefPreferredRouter() {
  const {peekingRouter, baseRouter} = useWeaveflowRouteContext();

  const {isInWorkspace} = useWeaveInWorkspace();
  return isInWorkspace ? baseRouter : peekingRouter;
}
